import { useFeatureFlag } from "@mma/common";
import React, { useContext, useEffect } from "react";
import { pathKey, securityCenter } from "../constants/static";
import { authorize } from "../endpoints/authorize";
import { StateContext } from "./stateContext";

export const AuthorizationContextProvider = ({ children }: { children?: React.ReactNode }) => {
  const authorizationCodeURL = new URLSearchParams(window.location.search).get("code");
  const { cidmUrl, setIsAuthorizeError, setAuthorizationCode, authorizationCode } = useContext(StateContext);
  const authorizedPath = !window.location.pathname.startsWith(`/${securityCenter}/legal`);
  const shouldUseExtendedScope = useFeatureFlag("MMA_hcsc_access_security_center", null as any);

  // Use effect to set authorization code from URL if present, this is for the case when user is redirected back to app after authorization
  useEffect(() => {
    if (authorizationCode) {
      return;
    }
    if (authorizationCodeURL) {
      setAuthorizationCode(new URLSearchParams(window.location.search).get("code") || "");
      return;
    }
  },[authorizationCode, authorizationCodeURL, setAuthorizationCode]);

  // Use effect to start authorization flow if user is on authorized path and no authorization code present, this is for the case when user lands on the page
  useEffect(() => {
    if (shouldUseExtendedScope === null) {
      return;
    }
    if (!cidmUrl) {
      return;
    }
    if (!authorizedPath) {
      return;
    }
    if (authorizationCode) {
      return;
    }

    sessionStorage.setItem(pathKey, window.location.pathname);
    authorize(cidmUrl, shouldUseExtendedScope).then(res => {
      setIsAuthorizeError(!!res?.isError);
    });
  }, [cidmUrl, shouldUseExtendedScope, authorizationCode]);

  if (!authorizationCode && authorizedPath) {
    return null;
  }

  return <>{children}</>;
};
